import { useState } from 'react';
import { Dialog, DialogContent } from '@mui/material';
import { useForm } from 'Hooks/useForm';
import CircularComponent from 'components/shared/CircularComponent';
import StatusSnackbar from 'components/shared/StatusSnackbar';
import { verifyRoutingNumber } from 'lib/api/kyb';
import { createBank } from 'lib/api/banks';
import { Button, Typography, FormControl, TextField, MenuItem } from '@mui/material';
import { Box } from '@mui/system';

export const ManualBankLink = ({ openManualLink, setOpenManualLink, fetchData }) => {
    const [showRoutingError, setShowRoutingError] = useState(false);
    const [confirmAcc, setConfirmAcc] = useState(true);
    const [loading, setLoading] = useState(false);
    const [showError, setShowError] = useState(false);

    const [openAlert, setOpenAlert] = useState(false);
    const [label, setLabel] = useState('');

    const [formValues, handleInputChange] = useForm({
        account_name: '',
        account_type: '',
        account_class: '',
        routing_number: '',
        bank_account_number: ''
    });

    const compareAccounts = () => {
        let val = formValues;
        if (val.bank_account_number === val.confirm_account_number) {
            setConfirmAcc(true);
            setShowError(false);
        } else {
            setConfirmAcc(false);
            setShowError(true);
        }
    };

    const verifyRouting = () => {
        let val = formValues;
        verifyRoutingNumber({
            routingNumber: val.routing_number
        })
            .then(response => {
                if (response) {
                    setShowRoutingError(false);
                }
            })
            .catch(error => {
                if (error.response?.data?.type === 'Bank/RoutingInvalid') {
                    setShowRoutingError(true);
                }
            });
    };

    const finishManualLink = () => {
        setLoading(true);
        let val = formValues;
        let payload = {
            name: val.account_name,
            accountNumber: val.bank_account_number,
            routingNumber: val.routing_number,
            accountType: val.account_type + val.account_class
        };
        createBank(payload)
            .then(response => {
                setLoading(false);
                fetchData();
                handleClose();
            })
            .catch(error => {
                if (error.response?.data?.type === 'Bank/BankAccountExists') {
                    setLabel('It seems this routing number and account number is already in your account');
                    setOpenAlert(true);
                    setLoading(false);
                }
            });
    };

    const handleClose = () => {
        setOpenManualLink(false);
    };
    return (
        <>
            <Dialog maxWidth="lg" open={openManualLink} onClose={handleClose}>
                <DialogContent
                    sx={{
                        minWidth: {
                            lg: '665px',
                            md: '665px',
                            sm: 'auto',
                            xs: 'auto'
                        },
                        minHeight: {
                            lg: '519px',
                            md: '519px',
                            sm: 'auto',
                            xs: 'auto'
                        },
                        padding: {
                            lg: '95px 91px 41px 94px!important',
                            md: '95px 91px 41px 94px!important'
                        }
                    }}>
                    {/*<Typography variant="h5" sx={{ contentTitle: "700!important" }}>
            Bank Account
          </Typography>
          <Typography variant="subtitle1" sx={{ color: "#A8B6C1" }}>
            Link your bank account to access your credit line
          </Typography>
  */}
                    <Box
                        sx={{
                            width: '100%'
                        }}>
                        <Box marginTop="20px" flexDirection="column">
                            <FormControl style={{ width: '60%' }}>
                                <Typography variant="subtitle2">Account Name</Typography>
                                <TextField
                                    size="small"
                                    name="account_name"
                                    placeholder="Enter name on account"
                                    onChange={handleInputChange}
                                />
                            </FormControl>
                        </Box>
                        <Box
                            style={{
                                width: '100%',
                                display: 'grid',
                                gridTemplateColumns: 'repeat(2,1fr)',
                                columnGap: '1em'
                            }}>
                            <Box marginTop="20px" flexDirection="column">
                                <FormControl style={{ width: '100%' }}>
                                    <Typography variant="subtitle2">Account Type</Typography>
                                    <TextField
                                        size="small"
                                        name="account_type"
                                        select
                                        placeholder="Enter name on account"
                                        onChange={handleInputChange}>
                                        <MenuItem value="business">Business</MenuItem>
                                        <MenuItem value="personal">Personal</MenuItem>
                                    </TextField>
                                </FormControl>
                            </Box>
                            <Box marginTop="20px" flexDirection="column">
                                <FormControl style={{ width: '100%' }}>
                                    <Typography variant="subtitle2">Account Class</Typography>
                                    <TextField
                                        size="small"
                                        select
                                        name="account_class"
                                        placeholder="Enter name on account"
                                        onChange={handleInputChange}>
                                        <MenuItem value="Checking">Checking</MenuItem>
                                        <MenuItem value="Savings">Savings</MenuItem>
                                    </TextField>
                                </FormControl>
                            </Box>
                        </Box>
                        <Box marginTop="20px" flexDirection="column">
                            <FormControl style={{ width: '60%' }}>
                                <Typography variant="subtitle2">Routing Number</Typography>
                                <TextField
                                    size="small"
                                    name="routing_number"
                                    placeholder="Enter routing number"
                                    onChange={handleInputChange}
                                    onBlur={verifyRouting}
                                />
                            </FormControl>
                            {showRoutingError ? (
                                <Typography sx={{ color: 'red', fontSize: '.75rem' }}>Invalid Routing Number</Typography>
                            ) : null}
                        </Box>
                        <Box
                            style={{
                                width: '100%',
                                display: 'grid',
                                gridTemplateColumns: 'repeat(2,1fr)',
                                columnGap: '1em'
                            }}>
                            <Box marginTop="20px" flexDirection="column">
                                <FormControl style={{ width: '100%' }}>
                                    <Typography variant="subtitle2">Bank Account Number</Typography>
                                    <TextField
                                        size="small"
                                        name="bank_account_number"
                                        placeholder="Enter bank account number"
                                        onChange={handleInputChange}
                                    />
                                </FormControl>
                            </Box>
                            <Box marginTop="20px" flexDirection="column">
                                <FormControl style={{ width: '100%' }}>
                                    <Typography variant="subtitle2">Confirm Bank Account Number</Typography>
                                    <TextField
                                        size="small"
                                        name="confirm_account_number"
                                        onBlur={compareAccounts}
                                        placeholder="Confirm bank account number"
                                        onChange={handleInputChange}
                                    />
                                </FormControl>
                                {showError ? (
                                    <Typography sx={{ color: 'red', fontSize: '.75rem' }}>
                                        Account numbers don't match.
                                    </Typography>
                                ) : null}
                            </Box>
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            marginTop: '5em',
                            paddingBottom: '2em',
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}>
                        {loading ? (
                            <CircularComponent />
                        ) : (
                            <Button variant="contained" disabled={!confirmAcc} onClick={() => finishManualLink()}>
                                Link Bank Account
                            </Button>
                        )}
                    </Box>
                </DialogContent>
            </Dialog>
            <StatusSnackbar label={label} severity={'error'} open={openAlert} setOpenAlert={setOpenAlert} needsAction={false} />
        </>
    );
};
